import InAppMessage from "./models/in-app-message.js";
import e from "../managers/braze-instance.js";
import ControlMessage from "./models/control-message.js";
import r from "../../shared-lib/braze-shared-lib.js";
import se from "./in-app-message-manager-factory.js";
export function deferInAppMessage(s) {
  if (e.rr())
    return s instanceof ControlMessage
      ? (r.j.info("Not deferring since this is a ControlMessage."), !1)
      : s instanceof InAppMessage
      ? se.m().he(s)
      : (r.j.info("Not an instance of InAppMessage, ignoring."), !1);
}
